import type { PillNodeAttrs } from "@smartsuite/smartdoc/lib/esm/extensions/pill/extension";
import { useRootStore } from "../../../../../../../../stores/hooks";
import type { PillPickerEditorCommands } from "@smartsuite/smartdoc/lib/esm/react/PillPickerEditor/PillPickerEditor";
import { CURRENT_ITEM_OUTPUT_ID } from "../../../../../../../../utils/constants";

export const useCurrentOption = ({
  fieldType,
  commandsRef,
}: {
  fieldType: string;
  commandsRef?: PillPickerEditorCommands | undefined;
}): {
  addCurrentPill: (attrs: PillNodeAttrs) => void;
} => {
  const store = useRootStore();

  const addCurrentPill = (attrs: PillNodeAttrs): void => {
    const pillValue = JSON.parse(attrs.value);
    // The loop ENCLOSING the open action, resolved past branch containers:
    // an action inside a Conditional Logic branch inside a loop still binds
    // its Current Item pill to that loop's source. The nearest-container
    // locator points at the branch there and silently dropped the pill.
    const loopSource = store.automations.candidate.currentLoopScope?.source;

    if (
      pillValue.target === "loop" &&
      loopSource?.oneofKind === "outputReference"
    ) {
      switch (loopSource.outputReference.source.oneofKind) {
        case "actionReference": {
          commandsRef?.addPill({
            ...attrs,
            value: JSON.stringify({
              outputId: CURRENT_ITEM_OUTPUT_ID,
              source: {
                oneofKind: "actionReference",
                actionReference:
                  loopSource.outputReference.source.actionReference,
              },
            }),
          });
          break;
        }
        case "triggerReference": {
          commandsRef?.addPill({
            ...attrs,
            value: JSON.stringify({
              outputId: CURRENT_ITEM_OUTPUT_ID,
              source: {
                oneofKind: "triggerReference",
                triggerReference:
                  loopSource.outputReference.source.triggerReference,
              },
            }),
          });
          break;
        }
        case "loopItem":
        default:
          break;
      }
    }
  };

  return {
    addCurrentPill,
  };
};
